<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.news-card {
    .zoom-wrapper {
        overflow: hidden;
        height: 223px;

        @media screen and (min-width: $screen-md) {
            height: 279px;
        }
    }

    .image-wrapper {
        background-size: cover;
        background-position: center;
        transition: transform 0.2s;
    }

    &:hover {
        .image-wrapper {
            transform: scale(1.1);
        }
    }
}
</style>

<template>
    <div class="news-card w-100">
        <a class="d-inline-block w-100" :href="`${newsUrl}/${newsItem.slug}`">
            <div class="zoom-wrapper w-100">
                <div class="image-wrapper w-100 lazyload h-100" :data-bg="newsItem.acf.image.sizes.small">

                </div>
            </div>

            <div class="news-content">
                <h3 class="mb-14" v-html="newsItem.title.rendered"></h3>
                <span class="read-more">{{ translations.read_more }}</span>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            newsUrl: route('news')
        }
    },
    
    props: {
        newsItem: {
            type: Object,
            required: true
        },
        translations: {
            type: Object,
            required: true
        },
    },
}
</script>